const Gb = () => {
	return (
		<svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clip-path='url(#clip0_11584_12758)'>
				<path
					d='M10.6662 31.0935V23.7335L5.17292 27.7868C6.71958 29.2268 8.58625 30.3468 10.6662 31.0935ZM21.3329 31.0935C23.4129 30.3468 25.2796 29.2268 26.8262 27.7868L21.3329 23.6802V31.0935ZM0.90625 21.3335C1.06625 21.8668 1.27958 22.3468 1.54625 22.8802L3.62625 21.3335H0.90625ZM28.3729 21.3335L30.4529 22.8802C30.6662 22.4002 30.8796 21.8668 31.0929 21.3335H28.3729Z'
					fill='#2A5F9E'
				/>
				<path
					d='M11.467 19.2002H0.320312C0.480312 19.9469 0.693646 20.6402 0.906979 21.3335H3.62698L1.54698 22.8802C1.97365 23.7869 2.45365 24.5869 3.04031 25.3869L8.53365 21.3335H10.667V22.4002L4.42698 26.9869L5.17365 27.7335L10.667 23.7335V31.0935C11.3603 31.3602 12.0536 31.5202 12.8003 31.6802V19.2002H11.467ZM31.6803 19.2002H19.2003V31.6802C19.947 31.5202 20.6403 31.3069 21.3336 31.0935V23.7335L26.827 27.7335C27.5736 27.0402 28.2136 26.2935 28.8536 25.4935L23.147 21.3335H26.7736L30.027 23.7335C30.187 23.4669 30.347 23.1469 30.4536 22.8802L28.3736 21.3335H31.0936C31.307 20.6402 31.5203 19.9469 31.6803 19.2002Z'
					fill='white'
				/>
				<path
					d='M3.04004 25.3868C3.46671 25.9735 3.89337 26.5068 4.37337 27.0402L10.6667 22.4535V21.3868H8.53337L3.04004 25.3868ZM23.2 21.3335L28.9067 25.4935C29.12 25.2268 29.28 24.9602 29.4934 24.6935C29.5467 24.6402 29.5467 24.5868 29.6 24.5868C29.76 24.3202 29.9734 24.0002 30.1334 23.7335L26.7734 21.3335H23.2Z'
					fill='#ED4C5C'
				/>
				<path
					d='M21.3329 0.906738V8.26674L26.8262 4.2134C25.2796 2.7734 23.4129 1.6534 21.3329 0.906738ZM10.6662 0.906738C8.58625 1.6534 6.71958 2.7734 5.17292 4.2134L10.6662 8.32007V0.906738ZM31.0929 10.6667C30.9329 10.1334 30.7196 9.6534 30.4529 9.12007L28.3729 10.6667H31.0929ZM3.62625 10.6667L1.54625 9.12007C1.33292 9.6534 1.11958 10.1334 0.90625 10.6667H3.62625Z'
					fill='#2A5F9E'
				/>
				<path
					d='M20.5336 12.8003H31.627C31.467 12.0536 31.2536 11.3603 31.0403 10.667H28.3203L30.4003 9.12031C29.9736 8.21365 29.4936 7.41365 28.907 6.61365L23.467 10.667H21.3336V9.60031L27.5736 5.01365L26.827 4.26698L21.3336 8.26698V0.906979C20.6403 0.640313 19.947 0.480312 19.2003 0.320312V12.8003H20.5336ZM0.320312 12.8003H12.8003V0.320312C12.0536 0.480312 11.3603 0.693646 10.667 0.906979V8.26698L5.17365 4.26698C4.42698 4.96031 3.78698 5.70698 3.14698 6.50698L8.85365 10.667H5.22698L1.97365 8.26698C1.81365 8.53365 1.65365 8.85365 1.54698 9.12031L3.62698 10.667H0.906979C0.693646 11.3603 0.480313 12.0536 0.320312 12.8003Z'
					fill='white'
				/>
				<path
					d='M28.9599 6.61329C28.5333 6.02663 28.1066 5.49329 27.6266 4.95996L21.3333 9.54663V10.6133H23.4666L28.9599 6.61329ZM8.79992 10.6666L3.14659 6.50663C2.93326 6.77329 2.77326 7.03996 2.55992 7.30663C2.50659 7.35996 2.50659 7.41329 2.45326 7.41329C2.29326 7.67996 2.07992 7.99996 1.91992 8.26663L5.17326 10.6666H8.79992Z'
					fill='#ED4C5C'
				/>
				<path
					d='M31.68 12.8H19.2V0.32C18.1867 0.106667 17.12 0 16 0C14.32 0 13.8133 0.106667 12.8 0.32V12.8H0.32C0.106667 13.8133 0 14.88 0 16C0 17.68 0.106667 18.1867 0.32 19.2H12.8V31.68C13.8133 31.8933 14.88 32 16 32C17.68 32 18.1867 31.8933 19.2 31.68V19.2H31.68C31.8933 18.1867 32 17.12 32 16C32 14.32 31.8933 13.8133 31.68 12.8Z'
					fill='#ED4C5C'
				/>
			</g>
			<defs>
				<clipPath id='clip0_11584_12758'>
					<rect width='32' height='32' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default Gb;
